import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData} from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import BillPrint from '../sale/Bill';
import PrintIcon from '@mui/icons-material/Print';
import Info from '@mui/icons-material/Info';
import ReactDOM from 'react-dom';
import AddIcon from '@mui/icons-material/Add';
import CopyrightIcon from '@mui/icons-material/Copyright';
import RefreshIcon from '@mui/icons-material/Refresh';


function SaleIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        // Token is not expired, fetch data
        fetchTableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    // here 4 parameter passing to help loading the infinte no:of data in index and fast loading 

    // Function to fetch table data and set state
    const fetchTableData = async () => {

        setData([]);
        try {
            const response = await fetchData('SaleApi', `/CustomerDetails/${companyId}/${branchId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }

    };

    // const fetchtableData = async () => {
    //     fetchData('SaleApi', `/${companyId}/${branchId}`, token)
    //         .then((response) => {
    //             if (response.responseCode === '1111') {
    //                 setData(response.response_data);
    //                 setFilteredData(response.response_data);
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Sale roup Details:', error);
    //             // Handle error, e.g., redirect to login if token is expired
    //             if (error.response && error.response.status === 401) {
    //                 logout();
    //                 // Redirect to login with the current location as a parameter
    //                 history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
    //             }
    //         });
    // };



    const handleDelete = async () => {
        deleteData('SaleApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchTableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('SaleApi', `${itemId}`, token)
            .then(() => {
                fetchTableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const handlePrint = async (saleid) => {
        try {

            const response = await fetchData('SaleApi', `/SalePrint/${saleid}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div className='w-full mb-2 flex'>
                <h5 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Sale </h5>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '200px' }}
                        />
                    )}
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <Button
                    style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '20px' }}
                    onClick={fetchTableData}
                    className="linkcolor"
                >
                    <IconButton onClick={fetchTableData}>
                        <RefreshIcon style={{ color: 'brown' }} />
                    </IconButton>
                    <span style={{ color: 'brown', fontWeight: 'bolder', marginTop: '-5px' }}>Refresh</span>
                </Button>


            </div>

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>
            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#58A5B3' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '3%' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%' }}>Bill Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '10%' }}>Bill Number</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '15%' }}>Customer Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '13%' }}>Contact Number</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>CSGT</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>SGST</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>IGST</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>Total</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', textAlign: 'center' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#C3E9E4' }}>
                            {filteredData.map((item, index) => (
                                <TableRow key={item.id} className={item.IsActive ? '' : 'inactiveRow'}>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '3%', fontSize: '14px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '7%', fontSize: '14px' }}>{formatDate(item.BillDate)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.BillPrefix}/{item.BillNumber}/{item.FinYear}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '15%', fontSize: '14px' }}>{item.CustomerName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '13%', fontSize: '14px' }}>{item.ContactNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', textAlign: 'center', fontSize: '14px' }}>{item.TaxableAmount ? item.TaxableAmount.toFixed(2) : "0.00"} </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '7%', textAlign: 'center', fontSize: '14px' }}>{item.CGSTAmount ? item.CGSTAmount.toFixed(2) : "0.00"}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '7%', textAlign: 'center', fontSize: '14px' }}>{item.SGSTAmount ? item.SGSTAmount.toFixed(2) : "0.00"}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '7%', textAlign: 'center', fontSize: '14px' }}>{item.IGSTAmount ? item.IGSTAmount.toFixed(2) : "0.00"}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '7%', textAlign: 'center', fontSize: '14px' }}>{item.GrandTotal ? item.GrandTotal.toFixed(2) : "0.00"}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', textAlign: 'right' }}>

                                        <IconButton component={Link} to={`/SaleDetails/${item.Id}`}>
                                            <Info style={{ color: 'coral', height: '22px' }} />
                                        </IconButton>

                                        <IconButton onClick={() => handlePrint(item.Id)}>
                                            <PrintIcon style={{ color: 'darkgoldenrod', height: '22px' }} />
                                        </IconButton>


                                        {hasEditMasterPermission && item.IsActive && (
                                            <IconButton component={Link} to={`/SaleEdit/${item.Id}`} color="primary">
                                                <EditIcon />
                                            </IconButton>
                                        )}

                                        {hasDeleteMasterPermission && (
                                            <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))} color="error">
                                                {item.IsActive ? <DeleteIcon /> : <ActivateIcon style={{ color: 'darkolivegreen', height: '22px' }} />}
                                            </IconButton>
                                        )}

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>

                    </Table>
                </TableContainer>
            </div>
        </div>

    );
}

export default SaleIndex;

